<template>
  <b-container fluid>
    <b-row>
      <b-col align-self="center">
        <call-card :call="call" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CallCard from '@/components/cards/CallCard'
import { errorOnDataLoad } from '@/services/messageService'
import { fetchNoticeRecipientById } from '@/services/noticesService'

export default {
  name: 'AttendeeCallDetails',
  components: {
    CallCard,
  },
  data() {
    return {
      call: {},
      isLoading: true,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.call = await fetchNoticeRecipientById(
          this.$route.params.id,
          'call'
        )
        this.isLoading = false
      } catch (error) {
        errorOnDataLoad({ context: this, error })
      }
    },
  },
}
</script>

<style scoped></style>
